// graphql.ts
import { gql } from "@apollo/client";

// Re-export ADD_TEMP_FILES from shared utils to avoid duplication
export { ADD_TEMP_FILES } from "../../utils/graphql";

export const ADD_SHARE_CLASS = gql`
  mutation AddShareClass($input: ShareClassInput!) {
    addShareClass(input: $input) {
      id
      name
    }
  }
`;

export const GET_SHARE_CLASS_PROFILE = gql`
  query GetShareClassProfile(
    $bucket: String!
    $Keys: [String!]!
    $investmentId: Int!
  ) {
    shareClassProfileBuilder(
      bucket: $bucket
      Keys: $Keys
      investmentId: $investmentId
    ) {
      answer
      conversationId
      shareClassProfiles {
        name
        status
        restricted
        isRcgNegotiated
        currencyDenominationEnumId
        otherFees
        investmentFees {
          mgmtFee
          mgmtFeeCalcEnumId
          mgmtFeeFreqEnumId
          incentiveFee
          incentiveFeeCalcEnumId
          incentiveFeeFreqEnumId
          otherFee
          otherFeeCalcEnumId
          otherFeeFreqEnumId
          highWaterMark
          annualReset
          hurdle
          hurdleBenchmark
          standardShareClassRates
          feeStructureChanged
          feeStructureChangedNotes
          abnormalFees
          abnormalFeesNotes
          peMgmtFeeCalcEnumId
          peIncentiveFeeCalcEnumId
          peMgmtFeeDuringCommitment
          peMgmtFeeDuringCommitmentCalcEnumId
          peMgmtFeeDuringHarvest
          peMgmtFeeDuringHarvestCalcEnumId
          hasMgmtFeeStepDown
          peMgmtFeeStepDownPercent
          peMgmtFeeStepDownCalcEnumId
        }
        liquidity {
          hasGate
          gatePercentNav
          gatePercentCapital
          exceptions
          hasLockup
          lockupValue
          lockupEndValueId
          lockupEndBizDays
          secondLockupEndValueId
          secondLockupEndBizDays
          lockupMonthlyValue
          subscriptionValue
          subscriptionUnitId
          liquidityValue
          liquidityUnitId
          liquidityMonthlyValue
          cashAvailableDays
          noticeValue
          noticeBizDays
          hasHoldback
          holdbackPercent
          workoutId
          modelingNotes
        }
        peLiquidity {
          preferredReturn
          isCompounded
          compoundingPeriodId
          hasCatchupProvision
          catchupPercent
          optionOfExtensionId
        }
      }
    }
  }
`;

export const GET_FEE_CALC_ENUM = gql`
  query GetFeeCalcEnum {
    feeCalcEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_FEE_FREQ_ENUM = gql`
  query GetFeeFreqEnum {
    feeFreqEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_PE_MGMT_FEE_CALC_ENUM = gql`
  query GetPEMgmtFeeCalcEnum {
    peMgmtFeeCalcEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_CALENDAR_UNIT_ENUM = gql`
  query GetCalendarUnitEnum {
    calendarUnitEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_LOCKUP_END_VALUE_ENUM = gql`
  query GetLockupEndValueEnum {
    lockupEndValueEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_RIGHT_OF_EXTENSION_ENUM = gql`
  query GetRightOfExtensionEnum {
    rightOfExtensionEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_COMPOUNDING_PERIOD_ENUM = gql`
  query GetCompoundingPeriodEnum {
    compoundingPeriodEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_WORKOUT_ENUM = gql`
  query GetWorkoutEnum {
    workoutEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_CURRENCY_DENOMINATION_ENUM = gql`
  query GetCurrencyDenominationEnum {
    currencyDenominationEnumList(
      filter: { isPerformanceCurrency: true }
      sort: { field: displayOrder, order: ASC }
    ) {
      items {
        id
        name
        displayOrder
      }
    }
  }
`;

export const GET_PE_INCT_FEE_CALC_ENUM = gql`
  query GetPEInctFeeCalcEnum {
    peInctFeeCalcEnumList {
      items {
        id
        name
      }
    }
  }
`;

export const GET_EXISTING_SHARE_CLASSES = gql`
  query GetExistingShareClasses($filter: ShareClassFilter!) {
    shareClassList(filter: $filter) {
      items {
        id
        investmentId
        name
        status
        restricted
        isRcgNegotiated
        currencyDenominationEnumId
        otherFees
        investmentFees {
          id
          mgmtFee
          mgmtFeeCalcEnumId
          mgmtFeeFreqEnumId
          incentiveFee
          incentiveFeeCalcEnumId
          incentiveFeeFreqEnumId
          otherFee
          otherFeeCalcEnumId
          otherFeeFreqEnumId
          highWaterMark
          annualReset
          hurdle
          hurdleBenchmark
          standardShareClassRates
          feeStructureChanged
          feeStructureChangedNotes
          abnormalFees
          abnormalFeesNotes
          peMgmtFeeCalcEnumId
          peIncentiveFeeCalcEnumId
          peMgmtFeeDuringCommitment
          peMgmtFeeDuringCommitmentCalcEnumId
          peMgmtFeeDuringHarvest
          peMgmtFeeDuringHarvestCalcEnumId
          hasMgmtFeeStepDown
          peMgmtFeeStepDownPercent
          peMgmtFeeStepDownCalcEnumId
        }
        liquidity {
          id
          hasGate
          gatePercentNav
          gatePercentCapital
          exceptions
          hasLockup
          lockupValue
          lockupEndValueId
          lockupEndBizDays
          secondLockupEndValueId
          secondLockupEndBizDays
          lockupMonthlyValue
          subscriptionValue
          subscriptionUnitId
          liquidityValue
          liquidityUnitId
          liquidityMonthlyValue
          cashAvailableDays
          noticeValue
          noticeBizDays
          hasHoldback
          holdbackPercent
          workoutId
          modelingNotes
        }
        peLiquidity {
          id
          preferredReturn
          isCompounded
          compoundingPeriodId
          hasCatchupProvision
          catchupPercent
          optionOfExtensionId
        }
      }
      total
    }
  }
`;

export const UPDATE_SHARE_CLASS = gql`
  mutation UpdateShareClass($id: Int!, $input: ShareClassInput!) {
    updateShareClass(id: $id, input: $input) {
      id
      name
    }
  }
`;
